import type { Signal } from '@angular/core';
import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';

import { PlansService } from '#/app/shared/services/api/plans.service';

import { resolveResourceAccessGuardResult } from './resource-access-guard';

/**
 * Guard that verifies a plan exists and belongs to the tenant in the route.
 * Prevents route matching if the plan doesn't exist or belongs to a different tenant,
 * allowing fallback routes to handle 404 display.
 */
export const planAccessCanMatchGuard: CanMatchFn = (
  _routes,
  _segments,
  _currentSnapshot,
) => {
  const plansService = inject(PlansService);
  const planIdParam = _currentSnapshot?.paramMap.get('planId') ?? '';

  return resolveResourceAccessGuardResult(planIdParam, (planIdSignal) =>
    plansService.planResource(planIdSignal as Signal<string>),
  );
};
